import { Component, OnInit, inject, viewChild } from '@angular/core';

import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { lastValueFrom, Observable } from 'rxjs';
import { BarManagementService, Organization, OrganizationQuery, OrganizationQueryResponse, OrganizationTag, TagQueryItem } from 'src/app/api/api-bar-management.service.generated';
import { MultiTagsComponent } from 'src/app/common/components/multi-tags/multi-tags.component';
import { TagsConverter } from './tags-converter';
import { ButtonComponent } from "wecheer-common";

@Component({
  selector: 'app-organization-tag-select',
  templateUrl: './organization-tag-select.component.html',
  styleUrls: ['./organization-tag-select.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    FlexLayoutModule,
    MultiTagsComponent,
    ButtonComponent
]
})
export class OrganizationTagSelectComponent implements OnInit {
  private bmApi = inject(BarManagementService);
  private dialogRef = inject<MatDialogRef<OrganizationTagSelectComponent>>(MatDialogRef);


  static async open(dialog: MatDialog): Promise<TagQueryItem[] | undefined> {
    const result = await lastValueFrom(dialog.open(OrganizationTagSelectComponent, { width: '600px', height: '600px', data: undefined }).afterClosed());
    return result as (TagQueryItem[] | undefined);
  }

  readonly multiTags = viewChild<MultiTagsComponent>('multiTags');

  isLoading = false;
  organizations: Organization[] = [];
  res: OrganizationQueryResponse;


  // tags
  availableTags$: Observable<string[]>;
  currentTags: OrganizationTag[] = [];
  tags: string[] = [];
  isTagsLoading = false;


  constructor() {
    const bmApi = this.bmApi;


    this.availableTags$ = bmApi.getTagSuggestions(undefined);
  }

  onSearch() {
    this.refresh();
  }

  async refresh() {
    if (this.tags.length === 0) {
      this.organizations = [];
      return;
    }

    try {
      this.isLoading = true;
      const tags = TagsConverter.toTags(this.tags).map(kv => new TagQueryItem({ tag: kv.tag, value: kv.value })); // remove invalid values
      const res = await lastValueFrom(this.bmApi.queryOrganizations(new OrganizationQuery({ tags: tags, skip: 0, maxItems: 100 })));
      this.organizations = res.items;
      this.res = res;
    } finally {
      this.isLoading = false;
    }
  }


  ngOnInit() {
  }

  onSelect() {
    const kvtags = TagsConverter.toTags(this.tags); // remove invalid values
    if (kvtags.length === 0) return;

    this.dialogRef.close(kvtags);
  }


}
